import React from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import AgendaEmptyState from './AgendaEmptyState';
import VisitCard from './VisitCard';
import { formatFullDate, getVisitsForDate, isToday } from '../utils/agendaDates';

const DailyAgendaView = ({
    selectedDate,
    visits,
    canEditVisits,
    canStartVisit,
    canFinishVisit,
    canReportVisit,
    canViewReport,
    isReportLocked,
    actionLoadingVisitId,
    locationLoadingVisitId,
    onEditVisit,
    onCancelVisit,
    onStartVisit,
    onFinishVisit,
    onReportVisit
}) => {
    const dayVisits = getVisitsForDate(visits, selectedDate);
    const clientVisits = dayVisits.filter((visit) => visit?.activityType !== 'office');
    const officeActivities = dayVisits.filter((visit) => visit?.activityType === 'office' && visit?.planningStatus !== 'cancelled');
    const plannedVisits = clientVisits.filter((visit) => visit?.planningStatus !== 'cancelled' && visit?.visitOrigin !== 'unplanned');
    const unplannedVisits = clientVisits.filter((visit) => visit?.planningStatus !== 'cancelled' && visit?.visitOrigin === 'unplanned');
    const cancelledVisits = dayVisits.filter((visit) => visit?.planningStatus === 'cancelled');
    const inProgressVisits = dayVisits.filter((visit) => visit?.executionStatus === 'inProgress');
    const pendingReportVisits = clientVisits.filter((visit) => visit?.executionStatus === 'pendingReport');
    const completedReportVisits = clientVisits.filter((visit) => visit?.executionStatus === 'completed' && visit?.planningStatus !== 'cancelled');
    const selectedIsToday = isToday(selectedDate);

    return (
        <Card className="ventas-day-card">
            <div className="flex flex-column sm:flex-row sm:align-items-start sm:justify-content-between gap-2">
                <div>
                    <div className="flex align-items-center gap-2 flex-wrap mb-1">
                        <h4 className="m-0 ventas-day-title">{formatFullDate(selectedDate)}</h4>
                        {selectedIsToday ? <Tag value="Hoy" severity="info" /> : null}
                    </div>
                    <p className="text-color-secondary mt-0 mb-0">Visitas y actividades del día seleccionado.</p>
                </div>
            </div>

            <Divider />

            <div className="grid ventas-summary-grid">
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">Planificadas</span>
                        <strong>{plannedVisits.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">Tiempo de oficina</span>
                        <strong>{officeActivities.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">No planificadas</span>
                        <strong>{unplannedVisits.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">Canceladas</span>
                        <strong>{cancelledVisits.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">En curso</span>
                        <strong>{inProgressVisits.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">Pendientes de reporte</span>
                        <strong>{pendingReportVisits.length}</strong>
                    </div>
                </div>
                <div className="col-12 sm:col-4">
                    <div className="ventas-summary-item">
                        <span className="text-color-secondary text-sm">Reportes completados</span>
                        <strong>{completedReportVisits.length}</strong>
                    </div>
                </div>
            </div>

            <div className="ventas-visits-area mt-3 ventas-visit-list">
                {dayVisits.length ? (
                    dayVisits.map((visit) => (
                        <VisitCard
                            key={visit._id}
                            visit={visit}
                                canEdit={typeof canEditVisits === 'function' ? canEditVisits(visit) : canEditVisits}
                            canStart={canStartVisit?.(visit)}
                            canFinish={canFinishVisit?.(visit)}
                            canReport={canReportVisit?.(visit)}
                            canViewReport={canViewReport?.(visit)}
                            reportLocked={isReportLocked?.(visit)}
                            actionLoading={actionLoadingVisitId === visit._id}
                            locationLoading={locationLoadingVisitId === visit._id}
                            onEdit={onEditVisit}
                            onCancel={onCancelVisit}
                            onStart={onStartVisit}
                            onFinish={onFinishVisit}
                            onReport={onReportVisit}
                        />
                    ))
                ) : (
                    <AgendaEmptyState message="No hay visitas ni actividades para este día." />
                )}
            </div>
        </Card>
    );
};

export default DailyAgendaView;
